<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="page-description">
          <h1>{{ $t('label.mapacoordenadasdasmudasplantadas') }}</h1>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end align-items-center">
        <router-link class="btn btn-primary ms-5" to="/coord-mudas/new">{{ $t('label.adicionar') }}</router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-md-12 flex-row align-self-center">
        <!-- busca lista -->
        <form class="fitro-lista" @submit.prevent="search">
          <div class="row">
            <div class="col-12 col-lg-6 mt-1">
              <v-select :appendToBody="true" :filterable="false" @search="getSpeciesCombo" :options="speciesList"
                v-model="$store.state.formSearch.id_species" label="text" index="id"
                :reduce="r => r.id" :clearable="false" class="bg-laranja-select vue-select">
                <template v-slot:selected-option="option">
                  {{ `${option.text}` }}
                </template>
                <template v-slot:option="option">
                  {{ `${option.text}` }}
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                  </template>
                </template>
              </v-select>
            </div>
            <div class="col-12 col-lg-6 mt-1">
              <v-select :appendToBody="true" :filterable="false" @search="getPropertiesCombo" :options="propertiesList"
                v-model="$store.state.formSearch.id_property" label="text" index="id"
                :reduce="r => r.id" :clearable="false" class="bg-laranja-select vue-select">
                <template v-slot:selected-option="option">
                  {{ `${option.text}` }}
                </template>
                <template v-slot:option="option">
                  {{ `${option.text}` }}
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                  </template>
                </template>
              </v-select>
            </div>
            <div class="col-md-12 d-flex justify-content-end mt-1 align-items-end">
              <button type="button" @click="clear" class="btn btn-outline-secondary">
                {{ $t('label.limpar') }}
              </button>
              <button type="submit" class="btn btn-primary ms-2">{{ $t('label.filtrar') }}</button>
            </div>
          </div>
        </form>
        <!-- /busca lista -->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div id="mapaCoordMudasContainer" style="height: 620px; width: 100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
export default {
  name: 'MapaCoordMudasView',
  data () {
    return {
      map: null,
      markersLayer: null,
      items: [],
      speciesList: [{ id_species: null, text: this.$t('label.nomecientificonomepopular') }],
      propertiesList: [{ id_property: null, text: this.$t('label.nomedapropriedade') }]
    }
  },
  mounted () {
    this.map = L.map('mapaCoordMudasContainer').setView([-19, -51], 4)
    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)
    this.markersLayer = L.layerGroup().addTo(this.map)
  },
  onBeforeUnmount () {
    if (this.map) {
      this.map.remove()
    }
  },
  methods: {
    clear: function () {
      this.$store.commit('clearFormSearch')
      this.search()
    },
    hasFilterSelected: function () {
      return !!(this.$store.state.formSearch.id_species || this.$store.state.formSearch.id_property)
    },
    search: function () {
      if (!this.hasFilterSelected()) {
        this.items = []
        this.markersLayer.clearLayers()
        return
      }
      this.$store.dispatch('showPreload')
      const params = this.$store.state.formSearch
      axios.get('/SeedlingCoord/GetToMap', { params })
        .then(response => {
          this.items = response.data
          this.loadMarkers()
        })
    },
    loadMarkers: function () {
      this.markersLayer.clearLayers()
      const LeafIcon = L.Icon.extend({
        options: {
          iconAnchor: [22, 94],
          shadowAnchor: [4, 62],
          popupAnchor: [-3, -76]
        }
      })
      const greenIcon = new LeafIcon({
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-icon.png'
      })
      this.items.forEach(e => {
        const marker = L.marker([e.lat, e.long], { icon: greenIcon }).addTo(this.markersLayer)
        const popupContent = `
          <div>
            <strong>Nome comum:</strong> ${e.common_name || '-'}<br/>
            <strong>Nome científico:</strong> ${e.latin_name || '-'}<br/>
            <strong>Lat:</strong> ${e.lat || '-'}<br/>
            <strong>Long:</strong> ${e.long || '-'}<br/>
            <strong>ID:</strong> ${e.id_seedling || '-'}<br/>
            <a href="/coord-mudas/${e.id_seedling}" target="_blank" rel="noopener">${this.$t('label.abrircoordenadamuda')}</a>
          </div>
        `
        marker.bindPopup(popupContent)
      })
      if (this.items.length) {
        this.map.setView([this.items[0].lat, this.items[0].long], 10)
      }
    },
    getSpeciesCombo: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.latin_name = search
        params.id_species = this.$store.state.formSearch.id_species
        loading(true)
        axios.get('/species/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ id_species: null, text: this.$t('label.nomecientificonomepopular') })
            loading(false)
          })
      } else if (!search) {
        params.id_species = this.$store.state.formSearch.id_species
        axios.get('/species/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ id_species: null, text: this.$t('label.nomecientificonomepopular') })
          })
      }
    },
    getPropertiesCombo: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.property = search
        params.id_property = this.$store.state.formSearch.id_property
        loading(true)
        axios.get('/planters/getallcombo', { params })
          .then(response => {
            this.propertiesList = response.data.items
            this.propertiesList.unshift({ id_property: null, text: this.$t('label.nomedapropriedade') })
            loading(false)
          })
      } else if (!search) {
        params.id_property = this.$store.state.formSearch.id_property
        axios.get('/planters/getallcombo', { params })
          .then(response => {
            this.propertiesList = response.data.items
            this.propertiesList.unshift({ id_property: null, text: this.$t('label.nomedapropriedade') })
          })
      }
    }
  },
  created () {
    this.getSpeciesCombo()
    this.getPropertiesCombo()
  }
}
</script>
